// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {actionMatches, hasEnoughDataToDetermineApplyTravel, shouldRunAdditionalAction} from '../../shared/services/claim-shared-helper';
import {resetConfirmationModal, setConfirmationModal} from './confirmation-modal';
import actions from '../../action-list';
import {addAuditVsrToClaim} from '../../shared/services/claim-vsr-helper';
import {additionalRepair} from './additional-repair';
import {bindActionCreators} from 'redux';
import {confirmationModalMap} from '../services/confirmation-modal-map';
import {copyClaim} from './copy-claim';
import {getClaim} from '../../shared/repositories';
import {readClaimProduct} from './get-product-details';
import {readShowApplyTravel} from './get-apply-travel';
import {updateSelectedAction} from './update-selected-action';

const handleRouteAction = (action, claim, dispatch) => {

    const actionsToBeBound = {
        resetConfirmationModal,
        updateSelectedAction
    };

    const boundActionCreators = bindActionCreators(actionsToBeBound, dispatch);

    const confirmActions = {
        adjust: boundActionCreators.updateSelectedAction.bind(null, action),
        delete: boundActionCreators.updateSelectedAction.bind(null, action),
        pushxml: boundActionCreators.updateSelectedAction.bind(null, action),
        reconcile: boundActionCreators.updateSelectedAction.bind(null, action),
        unreconcile: boundActionCreators.updateSelectedAction.bind(null, action),
        unsubmit: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    const actionMethod = confirmationModalMap(action, boundActionCreators.resetConfirmationModal, confirmActions);

    const map = {
        ADD_REP: additionalRepair,
        COPY_CLAIM: copyClaim,
        DIS_VSR: boundActionCreators.updateSelectedAction.bind(null, action),
        SUB: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    if (['RECONCILE', 'UNRECONCIL', 'DEL', 'REQ_ADDL', 'UNSUB', 'PUSH_XML'].includes(action.id)) {

        dispatch(setConfirmationModal(actionMethod));

    } else {

        map[action.id](claim)(dispatch);

    }

};

export const readNormalClaim = (claimNumber, action) =>

    /* eslint-disable complexity */

    async (dispatch, getState) => {

        let updatedClaim;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            updatedClaim = await getClaim(claimNumber, 'normal-claims');

            // adds special VSR for claim in audit status

            if (updatedClaim.claimStatus.key === 'ZADT') {

                updatedClaim = addAuditVsrToClaim(updatedClaim);

            }

            dispatch({
                type: actions.SET_CLAIM_NORMAL,
                updatedClaim
            });

            if (action && shouldRunAdditionalAction(action)) {

                handleRouteAction(action, updatedClaim, dispatch);

            }

            readClaimProduct(updatedClaim.pin)(dispatch, getState);

            // only request 'show apply travel' if enough data exists and we are not copying the claim

            if (hasEnoughDataToDetermineApplyTravel(updatedClaim) && !actionMatches(action, 'COPY_CLAIM')) {

                readShowApplyTravel(updatedClaim)(dispatch);

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

    /* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/normal/action-creators/get-normal-claim.js